import Pill from 'ext-ui/components/Pill/Pill'
import { tag_colorTagDefaultText } from 'ext-ui/style/colors'
import React, { ReactElement } from 'react'
import SvgEmail from 'src/components/Svgs/SvgEmail'
import { useTranslate } from 'src/localization/Trns'

import * as style from './NewInvitePill.style'

interface NewInvitePillProps {
  /**
   * Render as an inline <span> pill instead of the default ext-ui Pill (which
   * renders a <div>). Use when the pill sits inside phrasing-only content such
   * as a <button>, where a block element would be invalid markup.
   */
  inline?: boolean
}

/**
 * "New Invite" status pill, shown when a recipient is a brand-new contact being
 * invited to the org rather than an existing member. Shared by the confirm
 * card-assignment modal and the Assign Account Owner dropdown so both surfaces
 * read identically.
 */
const NewInvitePill: React.FC<NewInvitePillProps> = ({
  inline,
}): ReactElement => {
  const translate = useTranslate()

  const icon = (
    <SvgEmail
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill={tag_colorTagDefaultText}
    />
  )
  const label = translate('New Invite')

  if (inline) {
    return (
      <span css={style.inlinePill}>
        {icon}
        {label}
      </span>
    )
  }

  return (
    <Pill>
      <span css={style.content}>
        {icon}
        {label}
      </span>
    </Pill>
  )
}

export default NewInvitePill
